import type { UserProfile } from '@/types';
import axios from "axios";

export async function getUserProfile (): Promise<UserProfile> {
  const {data} = await axios.get('fetchProfile/', )
  return data as UserProfile
}

